module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('H1', [_vm._v("Raspored")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "foo"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }],
    staticClass: "input",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "date",
      "placeholder": "Za dan: ",
      "name": "email"
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "change": _vm.changedDate,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [(_vm.vacationsRequested.length > 0) ? _c('span', [_c('button', {
    staticClass: "button button-outline",
    staticStyle: {
      "background": "#2b542c",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.openRequested()
      }
    }
  }, [_c('i', {
    staticClass: "ti-bell"
  }), _vm._v(" Zahtevi za godisnji (" + _vm._s(_vm.vacationsRequested.length) + ")\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.vacationsNotes.length > 0) ? _c('span', [_c('button', {
    staticClass: "button button-outline",
    staticStyle: {
      "background": "coral",
      "color": "black"
    },
    on: {
      "click": function($event) {
        return _vm.openShowCommentModal()
      }
    }
  }, [_c('i', {
    staticClass: "ti-comment"
  }), _vm._v(" Napomene kurira (" + _vm._s(_vm.vacationsNotes.length) + ")\n              ")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.openAnotherShiftForCourier()
      }
    }
  }, [_c('u', [_vm._v("Otvori novu smenu")])]), _vm._v(" "), (_vm.isAdmin()) ? _c('div', [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "button button-outline",
    staticStyle: {
      "background": "lightgrey",
      "color": "black"
    },
    on: {
      "click": function($event) {
        return _vm.openSchedulePrint()
      }
    }
  }, [_c('i', {
    staticClass: "ti-printer"
  }), _vm._v(" Štampaj raspored\n              ")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "input",
    staticStyle: {
      "width": "90%",
      "border-radius": "10px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Pretraga",
      "name": "users"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showNotComplete),
      expression: "showNotComplete"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showNotComplete) ? _vm._i(_vm.showNotComplete, null) > -1 : (_vm.showNotComplete)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.showNotComplete,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showNotComplete = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showNotComplete = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showNotComplete = $$c
        }
      }
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.vacations.length > 0) ? _c('H3', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("Slobodni kuriri")]) : _vm._e()], 1), _vm._v(" "), (_vm.vacations.length > 0 || _vm.freeDaysDrivers.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed",
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_c('br'), _c('br'), _vm._v(" "), _c('tbody', [_vm._l((_vm.vacations), function(vacation, index) {
    return _c('tr', {
      staticStyle: {
        "color": "white",
        "background-color": "#4E5066 !important"
      }
    }, [_c('td', {
      staticStyle: {
        "width": "40px"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1000px"
      }
    }, [_vm._v(_vm._s(vacation.courier.firstName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1000px"
      }
    }, [_vm._v(_vm._s(vacation.courier.lastName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1000px"
      }
    }, [_vm._v(_vm._s(_vm.formatDate(vacation.date)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1000px"
      }
    }, [_vm._v(_vm._s(_vm.getDisplayStatus(vacation.status)) + " "), (vacation.status === 'APPROVED') ? _c('i', {
      staticClass: "ti-check",
      staticStyle: {
        "color": "greenyellow"
      }
    }) : _vm._e(), _vm._v(" "), (vacation.status === 'REJECTED') ? _c('i', {
      staticClass: "ti-close",
      staticStyle: {
        "color": "red"
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(vacation.notes))]), _vm._v(" "), (_vm.visibleButtons()) ? _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [(vacation.status === 'REQUESTED') ? _c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "cornflowerblue"
      },
      attrs: {
        "type": "button",
        "placeholder": "Odobri",
        "name": "Odobri",
        "value": "Odobri"
      },
      on: {
        "click": function($event) {
          return _vm.approveVacations(vacation)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.visibleButtons()) ? _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [(vacation.status === 'REQUESTED') ? _c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "#843534"
      },
      attrs: {
        "type": "button",
        "placeholder": "Odbij",
        "name": "Odbij",
        "value": "Odbij"
      },
      on: {
        "click": function($event) {
          return _vm.openDeclineVacationModal(vacation)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "ti-trash",
      staticStyle: {
        "color": "white"
      },
      on: {
        "click": function($event) {
          return _vm.deleteVacation(vacation)
        }
      }
    })])])
  }), _vm._v(" "), _vm._l((_vm.freeDaysDrivers), function(driver, index) {
    return _c('tr', {
      staticStyle: {
        "color": "white",
        "background-color": "#4E5066 !important"
      }
    }, [_c('td', {
      staticStyle: {
        "width": "40px"
      }
    }, [_vm._v(_vm._s(_vm.vacations.length + index + 1) + ".")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1000px"
      }
    }, [_vm._v(_vm._s(driver.firstName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1000px"
      }
    }, [_vm._v(_vm._s(driver.lastName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1000px"
      }
    }, [_vm._v(_vm._s(_vm.displayDate()))]), _vm._v(" "), _vm._m(1, true)])
  })], 2)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed",
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "40px",
      "color": "white"
    }
  }, [_vm._v("R. br")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Vozač")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Vozilo")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("Start")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Dnevni pazar")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Zarada")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Kuponi")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Gorivo/Rashod")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Dnevnica")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Radni sati")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Br. porudžbina")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("Počni dan")]), _vm._v(" "), (_vm.isAdmin()) ? _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("Zatvori dan")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("Izmena")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.filteredUsers), function(obj, index) {
    return _c('tr', {
      staticStyle: {
        "color": "white",
        "background-color": "#4E5066 !important"
      }
    }, [_c('td', {
      style: (obj.style)
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "10px",
        "color": "white"
      },
      style: (obj.style)
    }, [_vm._v(_vm._s(obj.courier.lastName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "10px",
        "color": "white"
      },
      style: (obj.style)
    }, [_vm._v(_vm._s(obj.vehicle.registrationPlate) + "  "), _c('button', {
      staticClass: "button-small button-outline",
      staticStyle: {
        "background": "#843534"
      },
      on: {
        "click": function($event) {
          return _vm.editVehicle(obj)
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    })])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "10px",
        "color": "white"
      },
      style: (obj.style)
    }, [_vm._v(_vm._s(obj.startShift == null ? "-" : obj.startShift) + "  "), (_vm.isVisibleDeleteButton()) ? _c('button', {
      staticClass: "button-small button-outline",
      staticStyle: {
        "background": "#843534"
      },
      on: {
        "click": function($event) {
          return _vm.changeStartShift(obj)
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "10px",
        "color": "white"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.round(obj.ordersPriceAmount)))]), _vm._v(" RSD")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "10px",
        "color": "white"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.round(obj.ordersPriceAmount - _vm.checkNull(obj.wage) - _vm.checkNull(obj.costs) - _vm.checkNull(obj.expense))))]), _vm._v(" RSD")]), _vm._v(" "), (obj.voucher === '' || obj.voucher == null) ? _c('td', [_vm._v("-")]) : _vm._e(), _vm._v(" "), (obj.voucher != null && obj.voucher !== '') ? _c('td', _vm._l((_vm.getVouchers(obj.voucher)), function(obj) {
      return _c('span', [_vm._v("\n                                    " + _vm._s(obj.count) + "\n                                   "), (obj.voucher === 'VOUCHER_GREEN') ? _c('img', {
        staticStyle: {
          "width": "20px",
          "height": "20px"
        },
        attrs: {
          "src": require("../../assets/img/coin.png")
        }
      }) : _vm._e(), _vm._v(" "), (obj.voucher === 'VOUCHER_BLUE') ? _c('img', {
        staticStyle: {
          "width": "20px",
          "height": "20px"
        },
        attrs: {
          "src": require("../../assets/img/coin_blue.png")
        }
      }) : _vm._e(), _vm._v(" "), (obj.voucher === 'VOUCHER_WHITE') ? _c('img', {
        staticStyle: {
          "width": "20px",
          "height": "20px"
        },
        attrs: {
          "src": require("../../assets/img/coin_white.png")
        }
      }) : _vm._e()])
    }), 0) : _vm._e(), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "10px",
        "color": "white"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.round(_vm.checkNull(obj.costs))) + " RSD / " + _vm._s(_vm.round(_vm.checkNull(obj.expense))) + " RSD")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "10px",
        "color": "white"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.round(_vm.checkNull(obj.wage))) + " RSD")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "10px",
        "color": "white"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.displayHoursAndMinutes(_vm.calculateHours(obj))))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "10px",
        "color": "white"
      }
    }, [_c('b', [_vm._v(_vm._s(obj.ordersNumber))])]), _vm._v(" "), (obj.startTime == null) ? _c('td', {
      staticStyle: {
        "padding": "5px"
      }
    }, [(_vm.isAdmin()) ? _c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "#2b542c"
      },
      attrs: {
        "type": "button",
        "placeholder": "Počni dan",
        "name": "Počni dan",
        "value": "Počni dan",
        "disabled": _vm.isDisabledAddButton
      },
      on: {
        "click": function($event) {
          return _vm.startDay(obj)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (obj.startTime != null) ? _c('td', {
      staticStyle: {
        "padding": "5px"
      }
    }, [_vm._v(_vm._s(_vm.formatDateToTime(new Date(obj.startTime))) + " "), (_vm.scheduleHasImages(obj)) ? _c('button', {
      staticClass: "button-small button-outline",
      staticStyle: {
        "background": "#843534"
      },
      on: {
        "click": function($event) {
          return _vm.getImages(obj)
        }
      }
    }, [_c('i', {
      staticClass: "ti-image",
      staticStyle: {
        "color": "white"
      }
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isAdmin()) ? _c('td', {
      staticStyle: {
        "padding": "5px"
      }
    }, [_c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "#2b542c"
      },
      attrs: {
        "type": "button",
        "placeholder": "Zatvroi dan",
        "name": "zatvrori",
        "value": "Zatvori dan",
        "disabled": _vm.isDisabledAddButton
      },
      on: {
        "click": function($event) {
          return _vm.completeDay(obj)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('td', [(_vm.isVisibleDeleteButton()) ? _c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "cornflowerblue"
      },
      attrs: {
        "type": "button",
        "placeholder": "Obriši",
        "name": "Obriši",
        "value": "Obriši"
      },
      on: {
        "click": function($event) {
          return _vm.deleteSchedule(obj)
        }
      }
    }) : _vm._e()])])
  }), _vm._v(" "), _vm._l((_vm.filteredDrivers), function(obj, index) {
    return _c('tr', {
      staticStyle: {
        "color": "white",
        "background-color": "#4E5066 !important"
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1 + _vm.filteredUsers.length) + ".")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "10px",
        "color": "white"
      },
      style: (obj.style)
    }, [_vm._v(_vm._s(obj.lastName))]), _vm._v(" "), (obj.visibleVehicle == null || obj.visibleVehicle === false) ? _c('td', {
      staticStyle: {
        "padding": "10px"
      }
    }, [_c('autocompleteObject', {
      attrs: {
        "suggestions": _vm.vehicles,
        "placeholder": _vm.placeholderVehicle
      },
      on: {
        "update:selectedModel": function($event) {
          return _vm.setNewVehicleInRow($event, obj)
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (obj.visibleVehicle === true) ? _c('td', {
      staticStyle: {
        "padding": "10px"
      }
    }, [_c('div', {
      staticStyle: {
        "color": "white"
      }
    }, [_vm._v(_vm._s(obj.vehicle.name) + "\n                            "), _c('button', {
      staticClass: "button-small button-outline",
      staticStyle: {
        "background": "#843534"
      },
      on: {
        "click": function($event) {
          return _vm.deleteVehicleForDriver(obj)
        }
      }
    }, [_c('i', {
      staticClass: "ti-close"
    })])])]) : _vm._e(), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "10px"
      }
    }, [_c('vue-timepicker', {
      staticStyle: {
        "color": "black"
      },
      attrs: {
        "format": "HH:mm",
        "close-on-complete": "",
        "auto-scroll": "",
        "drop-direction": "auto"
      },
      on: {
        "input": function($event) {
          return _vm.changeTimeForDriver($event, obj)
        }
      },
      model: {
        value: (obj.choosedTime),
        callback: function($$v) {
          _vm.$set(obj, "choosedTime", $$v)
        },
        expression: "obj.choosedTime"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "10px"
      }
    }, [_c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "#2b542c"
      },
      attrs: {
        "type": "button",
        "placeholder": "Dodaj",
        "name": "dodaj",
        "value": "Dodaj",
        "disabled": _vm.isDisabledAddButton
      },
      on: {
        "click": function($event) {
          return _vm.addScheduleForDriver(obj)
        }
      }
    })])])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "myModal"
    }
  }, [_c('h1', {
    staticStyle: {
      "color": "white",
      "font-size": "20px",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.selectedImage + 1) + "/" + _vm._s(_vm.images.length))]), _vm._v(" "), _c('span', {
    staticClass: "close",
    staticStyle: {
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_c('i', {
    staticClass: "ti-close"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticClass: "modal-content",
    attrs: {
      "id": "img01",
      "src": _vm.selected
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "caption"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "modal-prev",
    on: {
      "click": function($event) {
        return _vm.slideLeft()
      }
    }
  }, [_vm._v("❮")]), _vm._v(" "), _c('a', {
    staticClass: "modal-next",
    on: {
      "click": function($event) {
        return _vm.slideRight()
      }
    }
  }, [_vm._v("❯")])]), _vm._v(" "), _c('decline-vacation', {
    attrs: {
      "show": _vm.openDeclineVacation,
      "vacation": _vm.vacationToEdit
    }
  }), _vm._v(" "), _c('complete-day-modal', {
    attrs: {
      "show": _vm.openAddOrder,
      "schedule": _vm.scheduleToFinish
    }
  }), _vm._v(" "), _c('edit-schedule-vehicle-modal', {
    attrs: {
      "show": _vm.openEditVehicle,
      "schedule": _vm.editVehicleObj,
      "vehicles": _vm.vehicles
    }
  }), _vm._v(" "), _c('edit-schedule-shift-modal', {
    attrs: {
      "show": _vm.openEditShift,
      "schedule": _vm.editVehicleShiftObj
    }
  }), _vm._v(" "), _c('open-another-shift-modal', {
    attrs: {
      "show": _vm.openAnotherShift,
      "date": _vm.fromDate
    }
  }), _vm._v(" "), _c('show-comment-schedule-modal', {
    attrs: {
      "show": _vm.openShowComment,
      "notes": _vm.vacationsNotes
    }
  }), _vm._v(" "), _c('print-schedule', {
    attrs: {
      "show": _vm.openPrintSchedule
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('label', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "for": "checkbox"
    }
  }, [_vm._v("Prikaži samo nezatvorene dane"), _c('label', {
    staticStyle: {
      "color": "forestgreen"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "1000px"
    }
  }, [_vm._v("Dugoročni neradni dan "), _c('i', {
    staticClass: "ti-check",
    staticStyle: {
      "color": "greenyellow"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d203d6f8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Schedule/Schedule.vue
// module id = 511
// module chunks = 1